import { render, staticRenderFns } from "./fission-analysis.vue?vue&type=template&id=4b9961d0&scoped=true"
import script from "./fission-analysis.vue?vue&type=script&lang=ts"
export * from "./fission-analysis.vue?vue&type=script&lang=ts"
import style0 from "./fission-analysis.vue?vue&type=style&index=0&id=4b9961d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9961d0",
  null
  
)

export default component.exports